var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map__container ",class:{
    '--bigMap': _vm.bigMap,
    '--fullScreenMap': _vm.fullScreenMap,
  }},[_c('div',{class:{
      '--bigMap': _vm.bigMap,
      '--fullScreenMap': _vm.fullScreenMap,
    },attrs:{"id":"map"}})])}
var staticRenderFns = []

export { render, staticRenderFns }